'use strict';

var version = "0.0.0";

var url = getUrl();

function getUrl() {
  return window.location.href;
}

function getRedirectUri() {
  return url + '#close_window';
}

function getEmbedCode() {
  return '<iframe src=\'' + url + '\' width=\'560\' height=\'315\' frameborder=\'0\' allowfullscreen></iframe>';
}

var defaults = {
  title: 'Video',
  url: url,
  embedCode: getEmbedCode(),
  redirectUri: getRedirectUri()
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Button = videojs.getComponent('Button');

/**
 * send mail button.
 */

var SendMailButton = function (_Button) {
  inherits(SendMailButton, _Button);

  function SendMailButton(player, options) {
    classCallCheck(this, SendMailButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-menu-button');
    _this.addClass('vjs-mail-control');
    _this.addClass('vjs-icon-mail');
    _this.controlText(player.localize('mail'));
    return _this;
  }

  SendMailButton.prototype.handleClick = function handleClick() {
    this.player().getChild('SendMailOverlay').open();
  };

  return SendMailButton;
}(Button);

/**
 * @return {boolean}
 */


function _initFormEmail(options, player) {
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === "submit-form-mail") {
      submitFormMail(player);
    }
  });

  //-------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Mail validation
  //-------------------------------------------------------------------------------------------------------------------------------------------------------------
  function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
  }

  //-------------------------------------------------------------------------------------------------------------------------------------------------------------
  // // Send mail
  //-------------------------------------------------------------------------------------------------------------------------------------------------------------

  function submitFormMail(player) {
    var first_name = document.querySelector('#input-first-name').value;
    var your_email = document.querySelector('#input-your-email').value;
    var message = document.querySelector('#input-message').value;
    var error = 0;

    if (first_name.trim().length < 2) {
      document.querySelector('#input-first-name').classList.add('vjs-mail__error');
      error = 1;
    } else {
      document.querySelector('#input-first-name').classList.remove('vjs-mail__error');
    }
    if (!isValidEmailAddress(your_email)) {
      document.querySelector('#input-your-email').classList.add('vjs-mail__error');
      error = 1;
    } else {
      document.querySelector('#input-your-email').classList.remove('vjs-mail__error');
    }
    if (message.trim().length < 2) {
      document.querySelector('#input-message').classList.add('vjs-mail__error');
      error = 1;
    } else {
      document.querySelector('#input-message').classList.remove('vjs-mail__error');
    }
    var contentSendMail = { cryptedParam: "", to: "", from: "", title: "", message: "" };
    contentSendMail.cryptedParam = options.cryptedParam;
    contentSendMail.to = your_email;
    contentSendMail.from = first_name;
    contentSendMail.message = message;
    if (error === 0) {
      document.querySelector('#loading_mail').classList.add('show_loading');
      var HTTP = options.HTTP;
      var URL = options.URL;
      HTTP.post(URL, contentSendMail, {
        emulateJSON: true
      }).then(function (response) {
        if (response.data.code === 200) {
          console.log(response);
          document.querySelector('#loading_mail').classList.remove('show_loading');
        }
      }, function (response) {
        console.log('api error');
        player.trigger('error', { code: response.code, cause: response.message });
      });
    }
  }
}

var SendMailModalContent = function () {
    function SendMailModalContent(player, options) {
        classCallCheck(this, SendMailModalContent);

        this.player = player;
        this.options = options;
        this._createContent();
    }

    SendMailModalContent.prototype.getContent = function getContent() {
        return this.content;
    };

    SendMailModalContent.prototype._createContent = function _createContent() {
        var wrapper = document.createElement('div');

        wrapper.innerHTML = '<div class="vjs-mail">\n    <div class="vjs-mail__top hidden-sm">\n        <div class="vjs-mail__title">Envoyer par un mail</div>\n      </div>\n\n    <div class="vjs-mail__middle">\n\n            <div class="vjs-mail__content">\n                \n                <textarea class="vjs-mail__short-link" rows="1"  type="text" id="input-first-name" placeholder="Nom..."></textarea>\n            </div>\n            <div class="vjs-mail__content">\n                <textarea class="vjs-mail__short-link" rows="1"  type="text" id="input-your-email" placeholder="Email..."></textarea>\n            </div>\n             <div class="vjs-mail__content">\n                <textarea class="vjs-mail__short-link"rows="4" style="overflow : auto;" type="text" id="input-message" placeholder="Votre message"></textarea>\n            </div>\n            <div class="vjs-mail__action-buttons">\n            <div id="loading_mail" style="\n    background: #2f325e;\n    height: 0;\n    width: 0;\n    min-width: 36px;\n    /* top: -3px; */\n    cursor: pointer;\n    color: #fff;\n    font-size: small;\n    margin-right: 5px;\n    outline: none;\n    border: none;\n    position: relative;\n"><div class="lds-facebook"><div></div><div></div><div></div></div></div>\n                <input type="submit" tabindex="8" id="submit-form-mail"  value="Envoyer">\n            \n                <input type="submit" tabindex="8" id="cancel-form-mail" value="Annuler">\n            \n</div>\n    </div>\n</div>\n  ';
        this.content = wrapper.firstChild;
    };
    //-- Public Functions added to video-js

    return SendMailModalContent;
}();

var Component = videojs.getComponent('Component');

/**
 * send mail overlay.
 */

var SendMailOverlay = function (_Component) {
  inherits(SendMailOverlay, _Component);

  function SendMailOverlay(player, options) {
    classCallCheck(this, SendMailOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent();
    return _this;
  }

  SendMailOverlay.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-mail-overlay'
    });
  };

  SendMailOverlay.prototype._createContent = function _createContent() {
    var sendMail = new SendMailModalContent(this.player, this.options);
    var content = sendMail.getContent();
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), content);
    if (!this.hasClass('vjs-mail-overlay')) {
      this.addClass('vjs-mail-overlay');
    }
  };

  return SendMailOverlay;
}(Component);

var Component$1 = videojs.getComponent('Component');

/**
 * send mail overlay.
 */

var SendMail = function (_Component) {
  inherits(SendMail, _Component);

  function SendMail(player, options) {
    classCallCheck(this, SendMail);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.addChild('SendMailOverlay', options);
    _initFormEmail(options, player);
    return _this;
  }

  SendMail.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-mail-share'
    });
  };

  return SendMail;
}(Component$1);

// Default options for the plugin.
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.paramMail = options;
  player.addClass('vjs-videojs-mail');
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function sendMail
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var sendMail = function sendMail(options) {
  console.log(options);
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('SendMail', SendMail);
videojs.registerComponent('sendMailButton', SendMailButton);
videojs.registerComponent('sendMailOverlay', SendMailOverlay);

// Register the plugin with video.js.
registerPlugin('sendMail', sendMail);

var videojsPlayer = videojs.getComponent('Player');

//Lock the Slider bar and it will not be possible to change the arrow positions
videojsPlayer.prototype.uepSendMail = function (contentSendMail) {
  var HTTP = this.paramMail.HTTP;
  var URL = this.paramMail.URL;
  HTTP.post(URL, contentSendMail, {
    emulateJSON: true
  }).then(function (response) {
    if (response.data.code === 200) {
      console.log(response);
    }
  }, function (response) {
    console.log('api error');
    eventHub.$emit('error', { code: response.code, cause: response.message });
  });
};

// Include the version number.
sendMail.VERSION = version;

module.exports = sendMail;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_mail/dist/videojs-mail.cjs.js
// module id = 545
// module chunks = 1